import LabServiceModel from "@/models/LabServiceModel";
import ProcessScheduleModel from "@/models/lab/ProcessScheduleModel";
import InstrumentInstanceModel from "@/models/lab/InstrumentInstanceModel";
import InstrumentModel from "@/models/lab/InstrumentModel";
import ScheduleModel from "@/models/lab/ScheduleModel";

export default class ProcessScheduleInstrumentInstanceModel extends LabServiceModel {
  modelName() {
    return 'process-schedule-instrument-instance';
  }
  defaults() {
    return {
      id: null,
      process_schedule_id: null,
      instrument_id: null,
      instrument_instance_id: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      process_schedule_id: (val) => (this.nullStringMutator(val)),
      instrument_instance_id: (val) => (this.nullStringMutator(val)),
      created_at: String,
      updated_at: String,
      deleted_at: String,
    }
  }
  validation() {
    return {}
  }
  getSchedule() {
    return this.getRelatedModel(ScheduleModel, 'schedule');
  }
  getProcessSchedule() {
    return this.getRelatedModel(ProcessScheduleModel, 'process_schedule');
  }
  getInstrumentInstance() {
    return this.getRelatedModel(InstrumentInstanceModel, 'instrument_instance');
  }
  getInstrument() {
    return this.getRelatedModel(InstrumentModel, 'instrument');
  }
}
